export default __webpack_public_path__ + "static/media/amazon-store.d2e2e9a7.png";